import { Api, LocalDictionaryFactory } from '../../api/api.module'

import { IUserSession } from '../../../helpers/user-session'
import { HistoryController } from './history.directive.controller'

//#region Assets Imports

import './history.scss'
import * as TEMPLATE from './history.tpl.html'

//#endregion

export class HistoryDirective implements ng.IDirective {
    restrict = 'E'//only matches element name, odniesienie do layout.tpl.html simcards-create-edit
    scope = {
        "source": "=source"
    }

    controller = ['$scope', '$q', '$timeout', 'api', 'localDictionary', 'userSession',
        ($scope: any, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, localDictionary: LocalDictionaryFactory, userSession: IUserSession) =>
            new HistoryController($scope, $q, $timeout, api, localDictionary, userSession)]

    template = TEMPLATE
    replace = true
}

